export default {
  terms: 'Pogoji uporabe'
}